'use client'

import { useSearchParams, useRouter } from 'next/navigation'
import Card from '../ui/card'
import IcBedDouble from '~/icons/ic_bed_double'
import { useBookingCart } from '~/stores/booking-cart'
import { BookingStep, useBookingFlow } from '~/stores/booking-flow'
import { usePaymentData } from '~/hooks/use-payment-data'

import { useLocale } from '~/contexts/LocaleContext'
import { getTranslation } from '~/lib/i18n-utils'
interface RoomAvailabilityProps {
  onClose?: () => void
}

export default function RoomAvailability({ onClose }: RoomAvailabilityProps) {
  const { locale } = useLocale()
  const t = getTranslation(locale)
  const { clearCart } = useBookingCart()
  const { setCurrentStep, setCurrentPaymentStep } = useBookingFlow()
  const searchParams = useSearchParams()
  const router = useRouter()
  const { paymentData } = usePaymentData()
  const hotelId = searchParams.get('hotelId')

  const handleClose = () => {
    setCurrentPaymentStep(1)
    setCurrentStep(BookingStep.LIST)
    clearCart()
    const params = new URLSearchParams()
    params.set('hotelId', hotelId || '')
    params.set('checkInDate', paymentData?.arrivalDate || '')
    params.set('checkOutDate', paymentData?.departureDate || '')
    params.set('adults', String(paymentData?.cardItems?.[0]?.guests?.adults || 1))
    params.set('kidsOver6', String(paymentData?.cardItems?.[0]?.guests?.children6To12 || 0))
    params.set('kidsUnder6', String(paymentData?.cardItems?.[0]?.guests?.childrenUnder6 || 0))
    const url = `/?${params.toString()}`

    router.push(url)
    onClose?.()
  }

  return (
    <Card className="xs:mb-4 max-w-[520px] pb-0 pl-10 pr-10 pt-2" padding={0}>
      <div className={`mx-auto w-full`}>
        <div className="mb-4 flex justify-center">
          <div className="flex h-16 w-16 items-center justify-center rounded-full">
            <IcBedDouble />
          </div>
        </div>

        <h2 className="mb-4 text-center text-xl font-medium text-[#2D2E32]">
          {t('payment.roomChangedTitle')}
        </h2>
        <p className="mb-6 text-center text-[14px] font-[350] leading-relaxed text-[#666B74]">
          {t('payment.roomChangedDesc')}
        </p>
        <button
          onClick={handleClose}
          className="w-full items-center justify-center gap-2 rounded bg-primary-500 p-3 text-base text-white"
        >
          {t('common.close')}
        </button>
      </div>
    </Card>
  )
}
